<template>
  <div v-loading="true" class="flex-grow"></div>
</template>

<script>
  export default {
    name: 'AuthCallback',
    mounted: function() {
      var params = [];
      for(let key in this.$route.query) {
        params.push(key + '=' + this.$route.query[key]);
      }

      let url = this.$store.state.API_URL+(this.$store.state.env === "development" ? 'auth/' : 'connect/')+this.$route.params.provider+'/callback?'+params.join("&");

      const afterTokenSet = () => {
        let redirect = localStorage.getItem("loginRedirect");
        if (redirect !== null) {
          localStorage.removeItem("loginRedirect");
          window.location.href = redirect;
        } else {
          this.$router.push(this.$store.state.loginRedirect ? this.$store.state.loginRedirect : '/my-library')
        }
      };

      window.addEventListener("load", () => {
        this.$store.dispatch('authRequest', {
          identifier: '',
          password: '',
          method: 'GET',
          url: url
        }).then((resp) => {
          if (resp.error) {
            this.$message.error(resp.error);
            this.$router.push("/login");
          } else {
            if (this.$store.state.env === "development") {
                let tokenWin = document.getElementById('token-iframe');
                tokenWin.contentWindow.postMessage({
                  jwt: resp.data.jwt,
                }, '*');
                afterTokenSet()
            } else {
              afterTokenSet();
            }

          }
        })
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/AuthCallback.vue